import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEqual } from 'lodash';
import { mapActions } from 'vuex';
// import {
//   fetchTruckNoList
// } from '@/api/alarm/driver';

import TeamTree from '@/components/TeamTree/index';
export default {
  name: 'TeamtreeCar',
  components: {
    TeamTree: TeamTree
  },
  props: {
    checkStrictly: {
      type: Boolean,
      default: false
    },
    isShowCarNo: {
      type: Boolean,
      default: true
    },
    singleChoose: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    carNoLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    teamCodeLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      truckNoList: [],
      truckNoListAll: [],
      truckNoListFilter: [],
      teamCodeList: [],
      carNoList: [],
      carScrollIndex: 0,
      loading: false,
      SELECTWRAP_DOM: null
    };
  },
  watch: {
    carNoLists: {
      handler: function handler(v, o) {
        if (isEqual(v, o)) return;
        this.carNoList = this.carNoLists;
      },
      deep: true,
      immediate: true
    },
    teamCodeLists: {
      handler: function handler(v, o) {
        if (isEqual(v, o)) return;
        this.teamCodeList = this.teamCodeLists;
      },
      deep: true,
      immediate: true
    },
    teamCodeList: function teamCodeList(v, o) {
      if (isEqual(v, o)) return;
      this.carScrollIndex = 0;
      this.truckNoList.splice(0, this.truckNoList.length);
      this.truckNoList = [];
      this.carNoList.splice(0, this.carNoList.length);
      this.carNoList = [];
      this.getTruckNoList();
    }
  },
  mounted: function mounted() {
    this.SELECTWRAP_DOM = this.$refs.selectlazyload.$el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    this.SELECTWRAP_DOM.addEventListener('scroll', this.infinityload);
    // this.SELECTWRAP_DOM.addEventListener('scroll', function() {
    //   const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
    //   if (CONDITION) {
    //     self.load()
    //   }
    // })
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.getTruckNoList();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  destroyed: function destroyed() {
    this.SELECTWRAP_DOM.removeEventListener('scroll', this.infinityload);
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    securityCarNumber: 'securityCarNumber'
  })), {}, {
    infinityload: function infinityload() {
      var CONDITION = this.SELECTWRAP_DOM.scrollHeight - this.SELECTWRAP_DOM.scrollTop <= this.SELECTWRAP_DOM.clientHeight + 5;
      if (CONDITION) {
        this.load();
      }
    },
    load: function load() {
      var _this = this;
      this.truckNoList = this.truckNoListFilter.filter(function (item, index) {
        return index < (_this.carScrollIndex + 1) * 20;
      });
      this.$nextTick(function () {
        _this.carScrollIndex++;
      });
    },
    getTruckNoList: function getTruckNoList() {
      var _this2 = this;
      this.securityCarNumber({
        teamCodeList: this.teamCodeList
      }).then(function (response) {
        var _this2$truckNoList;
        _this2.truckNoListAll = response && response.data;
        _this2.truckNoListFilter = _toConsumableArray(_this2.truckNoListAll);
        var data = _this2.truckNoListAll.filter(function (item, index) {
          return index < 20;
        });
        (_this2$truckNoList = _this2.truckNoList).push.apply(_this2$truckNoList, _toConsumableArray(data));
        _this2.$nextTick(function () {
          _this2.carScrollIndex++;
        });
      });
    },
    filtermethod: function filtermethod(v) {
      var _this3 = this;
      this.carScrollIndex = 0;
      this.truckNoList.splice(0, this.truckNoList.length);
      this.truckNoList = [];
      this.$nextTick(function () {
        var _this3$truckNoList;
        _this3.truckNoListFilter = _this3.truckNoListAll.filter(function (item) {
          return item.value.indexOf(v) !== -1;
        });
        var data = _this3.truckNoListFilter.filter(function (item, index) {
          return index < 20;
        });
        (_this3$truckNoList = _this3.truckNoList).push.apply(_this3$truckNoList, _toConsumableArray(data));
        _this3.$nextTick(function () {
          _this3.carScrollIndex++;
          _this3.SELECTWRAP_DOM.scrollTop = 0;
        });
      });
    },
    change: function change(v) {
      this.$emit('update:carNoLists', v);
    },
    input: function input(v) {
      this.teamCodeList = v;
      this.$emit('update:teamCodeLists', v);
    }
  })
};